<div class="db-cdn-general__header mb25">
  <div>
    <h2 class="title">Cloudflare Enterprise</h2>
    <p class="url">{{websiteUrl}}</p>
  </div>

  <ng-container *ngIf="isStatusPending">
    <div class="db-cdn-general__status-wrap"
         [firstTimeHighlight]="recordTooltipHighlight"
         [highlightedElement]="'db-cdn-general__status'"
         [showBtn]="false"
         [hasCloseBtn]="false" [animation]="false"
         [localStorageKey]="'cdnHighlight'"
         [align]="'right'" [customStyles]="'background: #FFF9EA;'">
      <div class="db-cdn-general__status yellow pointer mr10"
           [ngClass]="{'ds-lazy-load': initialLoading}"
           [dsTooltip]="recordTooltipHighlight"
           [dsTooltipMode]="'hoverStatic'"
           dsTooltipPosition="bottom"
           dsTooltipAlign="right">
        <i class="db-icon db-icon-info-lined small mr10"></i>
        <div class="separator mr10"></div><p>Pending DNS records update</p>
      </div>

      <div class="db-cdn-general__status yellow pointer"
           [ngClass]="{'ds-lazy-load': initialLoading}"
           [dsTooltip]="'<h4>Verify DNS</h4>'"
           dsTooltipColor="black"
           dsTooltipSize="small"
           dsTooltipPosition="bottom"
           dsTooltipAlign="right"
           (click)="verifyDNS()">
        <i class="db-icon db-icon-ds-refresh small" [ngClass]="{'rotating': loading}"></i>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isStatusPending">
    <div class="db-cdn-general__status green relative"
         [ngClass]="{'ds-lazy-load': initialLoading}">
      <p class="mr10">Active</p><div class="separator mr6"></div><i class="db-icon db-icon-ds-checkmark-bg green"></i>
      <div *ngIf="isDNSCacheTooltipHidden" class="db-cdn-static-tooltip bottom">
        <p class="mb10">Please clear your DNS cache to view<br> Cloudflare version of your website.</p>
        <p class="text-right" (click)="hideDNSCacheTooltip()"><b>Got It</b></p>
      </div>
    </div>
  </ng-container>
</div>

<div class="ds-notification-error mb10" *ngIf="!initialLoading && cloudflareHostname !== websiteUrl">
  <div>
    <i class="db-icon db-icon-ds-exclamation-bg"></i>
    <p>
      Cloudflare is currently enabled for {{cloudflareHostname}}. If you wish to enable it for {{websiteUrl}}, please disable Cloudflare on {{cloudflareHostname}} and enable it again for the intended domain.
    </p>
  </div>
</div>

<div class="db-cdn-general__card"
     [ngClass]="{'ds-lazy-load': initialLoading}">
  <div class="mr50">
    <p class="subtitle">Bandwidth</p>
    <p class="bandwith" [innerHTML]="bandwidth || 0"></p>
  </div>

  <div>
    <p class="title mb4"><span><span [innerHTML]="bandwidth"></span> used from the available <span [innerHTML]="((userSubscription?.plan?.cdnBandwidthValue + (userSubscription?.plan?.additionalCDNCount ? (userSubscription?.plan?.cdnAdditionalBandwidthValue * userSubscription?.plan?.additionalCDNCount) : 0)) | size: {unit: 'MB'}) + ' Bandwidth'"></span> account bandwidth</span>
      <i class="db-icon db-icon-info-lined info ml5"
         [dsTooltip]="bandwithTooltip"
         dsTooltipPosition="bottom"
         dsTooltipAlign="left"></i>
    </p>
  </div>
</div>

<p class="db-desc mt15">You’re seeing data for the current month. Updated every 24 hours.</p>

<ng-container *ngIf="!initialLoading && ((userSubscription?.plan?.cdnBandwidthValue + (userSubscription?.plan?.additionalCDNCount ? (userSubscription?.plan?.cdnAdditionalBandwidthValue * userSubscription?.plan?.additionalCDNCount) : 0))) <= bandwidthNumber">
  <div class="ds-notification-info mt10" *ngIf="paymentType === 'card'; else paypalView">
    <div>
      <i class="db-icon db-icon-ds-info-bg"></i>
      <p>
        For every additional <span [innerHTML]="userSubscription?.plan?.cdnBandwidthBaseValue | size:{unit: 'MB'}"></span> over account bandwidth you’ll be charged an extra 5$ at the end of billing period.
      </p>
    </div>
  </div>
</ng-container>

<ng-template #paypalView>
  <div class="ds-notification-error mt10">
    <div>
      <i class="db-icon db-icon-ds-exclamation-bg"></i>
      <p>
        For every additional <span [innerHTML]="userSubscription?.plan?.cdnBandwidthBaseValue | size:{unit: 'MB'}"></span> over account bandwidth you’ll be charged an extra 5$ at the end of billing period.<br>
        Additional fees can’t be charged via PayPal, you need to <a [routerLink]="['/workspace/subscription-plan']">add alternative payment method</a>.
      </p>
    </div>
  </div>
</ng-template>


<ng-template #bandwithTooltip>
  <p>On average 100GB bandwidth<br> is equivalent to 50K visitors.</p>
</ng-template>


<ng-template #recordTooltipHighlight>
  <div class="db-cdn-general__record-tooltip">
    <h4 class="mb8">Confirming your domain was pointed<br/> to Cloudflare</h4>
    <p class="mb10">We are checking your DNS records to<br/> confirm that you have pointed your<br/>
      domain to Cloudflare. This process can<br/> take up to 24 hours.</p>
  </div>
</ng-template>
